import { NBSP } from '../../../../constants/symbols';
import { EBetPositionErrorCode } from '../../../../redux/reducers';

/**
 *
 * @description Функция-фабрика, возвращает ошибку валидации для запроса прогноза позиции объявления.
 * Если для ошибок понадобится стилизация - заменить renderErrorMessage на компонент ServicePositionErrorMessage
 */
export function renderErrorMessage(errorCode: EBetPositionErrorCode | null): string | null {
  switch (errorCode) {
    case EBetPositionErrorCode.priceAndGeoEmpty:
      return `Введите адрес и${NBSP}цену объекта, чтобы${NBSP}увидеть, на${NBSP}какой странице поиска он окажется`;

    case EBetPositionErrorCode.geoEmpty:
      return `Введите адрес объекта, чтобы${NBSP}увидеть, на${NBSP}какой странице поиска он окажется`;

    case EBetPositionErrorCode.priceEmpty:
      return `Введите цену объекта, чтобы${NBSP}увидеть, на${NBSP}какой странице поиска он окажется`;

    case EBetPositionErrorCode.serviceNotSupported:
      return `Данная услуга размещения не${NBSP}поддерживает старницу поиска объекта`;

    case EBetPositionErrorCode.minimalBetReached:
    case EBetPositionErrorCode.maximalBetReached:
    case EBetPositionErrorCode.betNotDivided:
      return `Измените ставку объекта, чтобы${NBSP}увидеть, на${NBSP}какой странице поиска он окажется`;

    case EBetPositionErrorCode.serverError:
      return `Ошибка на${NBSP}сервере. Страница поиска объекта не${NBSP}загрузилась`;

    default:
      return null;
  }
}
